<template>
  <footer id="contact" v-reveal class="footer">
    <div class="footer-inner">
      <div class="footer-grid">
        <div class="footer-left">
          <img :src="headerLogo" alt="logo" class="company-logo" />
          <div class="qr-row">
            <div class="qr-item">
              <img class="qr-img lift-hover lift-hover--soft" :src="basicInfo.contactQrCode" alt="" />
              <span class="qr-caption">{{ $t("qrCaptionContact") }}</span>
            </div>
            <!-- <div class="qr-item">
              <img class="qr-img lift-hover lift-hover--soft" :src="basicInfo.wechatQrCode" alt="" />
              <span class="qr-caption">{{ $t("qrCaptionWechat") }}</span>
            </div> -->
          </div>
        </div>
        <div class="footer-right">
          <div class="footer-right-inner">
            <div class="contact-lines">
              <p>
                <span class="label">{{ $t("preSalesConsult") }}</span>
                <span class="value">{{ basicInfo.preSalesPhone }}</span>
              </p>
              <p>
                <span class="label">{{ $t("afterSalesConsult") }}</span>
                <span class="value">{{ basicInfo.afterSalesPhone }}</span>
              </p>
              <p class="email-line">
                <span class="label">{{ $t("email") }}</span>
                <span class="value">{{ basicInfo.email }}</span>
              </p>
            </div>
            <div class="footer-legal">
            <p v-if="legalLinePrefix || filingNumber" class="legal-line legal-primary">
              <span v-if="legalLinePrefix">{{ legalLinePrefix }}</span>
              <span v-if="filingNumber" class="icp-row">
                <img :src="filingIconUrl" alt="" class="filing-icon" />
                <a
                  :href="filingLink"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="filing-link"
                >{{ filingNumber }}</a>
              </span>
            </p>
            <div v-if="basicInfo.policeFilingNumber" class="legal-line police-row">
              <svg
                class="police-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="14"
                height="16"
                aria-hidden="true"
              >
                <path
                  fill="currentColor"
                  d="M12 1L3 5v6c0 5.55 3.84 10 9 11 5.16-1 9-5.45 9-11V5l-9-4zm0 2.18l6 2.67V11c0 4.52-3.13 8.44-6 9.93-2.87-1.49-6-5.41-6-9.93V5.85l6-2.67z"
                />
              </svg>
              <span class="police-text">{{ basicInfo.policeFilingNumber }}</span>
            </div>
            <p v-if="basicInfo.address" class="legal-line legal-address">
              <span class="addr-label">{{ $t("address") }}</span>
              <span class="addr-text">{{ basicInfo.address }}</span>
            </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import headerLogo from "@/static/logo.jpg";

export default {
  props: {
    basicInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      headerLogo,
      filingIconUrl:
        "https://static.distributetop.com/wms-nuxt-office/wms-site-upload/_nuxt/filing.Cah3uH1L.png",
      filingLink: "https://beian.miit.gov.cn/#/Integrated/recordQuery"
    };
  },
  computed: {
    displayYear() {
      return new Date().getFullYear();
    },
    filingNumber() {
      return (this.basicInfo.filingNumber || "").trim();
    },
    legalLinePrefix() {
      const name = (this.basicInfo.companyName || "").trim();
      if (!name && !this.filingNumber) {
        return "";
      }
      const mark = this.$t("copyrightMark");
      const parts = [];
      if (name) {
        parts.push(name);
      }
      parts.push(`${mark} ©${this.displayYear}`);
      return parts.join(" ");
    }
  }
};
</script>

<style scoped>
.footer {
  width: 100%;
  margin: 0;
  padding: 48px 0 56px;
  border-radius: 0;
  background: #1a1d24;
  color: rgba(255, 255, 255, 0.88);
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  font-size: 18px;
  line-height: 1.6;
}

.footer-inner {
  width: 80%;
  max-width: 1280px;
  margin: 0 auto;
}

.footer-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
  gap: 40px 72px;
  align-items: stretch;
}

.footer-left {
  min-width: 0;
}

.footer-right {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.footer-right-inner {
  margin-top: auto;
  text-align: right;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 28px;
}

.footer-legal {
  width: 100%;
}

.company-logo {
  display: block;
  max-height: 150px;
  max-width: 220px;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}

.company-logo:hover {
  transform: scale(1.03);
}

.qr-row {
  display: flex;
  flex-wrap: wrap;
  gap: 28px 32px;
  margin-bottom: 28px;
}

.qr-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 120px;
}

.qr-img {
  width: 112px;
  height: 112px;
  background: #fff;
  border-radius: 0;
  display: block;
}

.qr-caption {
  margin-top: 10px;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.55);
  text-align: center;
}

.contact-lines {
  width: 100%;
}

.contact-lines p {
  margin: 0 0 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: flex-end;
  gap: 6px 10px;
}

.contact-lines .label {
  color: rgba(255, 255, 255, 0.45);
  font-size: 15px;
}

.contact-lines .value {
  font-size: 19px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.95);
}

.email-line .value {
  font-size: 17px;
  font-weight: 400;
}

.legal-line {
  margin: 0;
  font-size: 13px;
  line-height: 2.15;
  color: rgba(255, 255, 255, 0.45);
}

.legal-primary {
  margin-bottom: 6px;
  letter-spacing: 0.02em;
}

.police-row {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 4px;
  width: 100%;
  font-size: 12px;
  line-height: 2.4;
  color: rgba(255, 255, 255, 0.42);
}

.police-icon {
  flex-shrink: 0;
  color: #c9a962;
  opacity: 0.95;
}

.police-text {
  letter-spacing: 0.08em;
}

.legal-address {
  margin-top: 4px;
  font-size: 12px;
  line-height: 2.3;
  color: rgba(255, 255, 255, 0.4);
}

.addr-label {
  margin-right: 4px;
}

.addr-text {
  letter-spacing: 0.02em;
}

.icp-row {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
}

.filing-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.filing-link {
  color: inherit;
  text-decoration: none;
}

.filing-link:hover {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: underline;
}

@media (prefers-reduced-motion: reduce) {
  .company-logo:hover {
    transform: none;
  }
}

@media (max-width: 991px) {
  .footer {
    padding: 36px 0 44px;
    font-size: 17px;
  }

  .footer-inner {
    width: 88%;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 36px;
  }

  .footer-right-inner {
    margin-top: 0;
    text-align: left;
    align-items: flex-start;
  }

  .contact-lines p {
    justify-content: flex-start;
  }

  .police-row {
    justify-content: flex-start;
  }
}

@media (max-width: 575px) {
  .footer-inner {
    width: 92%;
  }

  .qr-item {
    width: 108px;
  }

  .qr-img {
    width: 100px;
    height: 100px;
  }
}
</style>
